var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03725 0 0 4.03725 0 9C0 13.9628 4.03725 18 9 18C13.9628 18 18 13.9628 18 9C18 4.03725 13.9628 0 9 0ZM8.625 14.25C8.004 14.25 7.5 13.746 7.5 13.125C7.5 12.504 8.004 12 8.625 12C9.246 12 9.75 12.504 9.75 13.125C9.75 13.746 9.246 14.25 8.625 14.25ZM11.8582 7.59525C11.6265 7.9665 11.1862 8.3835 10.5367 8.847C9.486 9.624 9.5145 9.7965 9.5145 10.5H7.67175C7.67175 9.95025 7.65975 9.528 7.95675 9.01425C8.1465 8.685 8.4945 8.33475 9 7.96425C9.60675 7.53075 10.1962 7.113 10.1962 6.3855C10.1962 5.70375 9.61275 5.46075 8.931 5.46075C8.23575 5.46075 7.443 5.688 6.55275 6.1425L5.7945 4.62C7.41225 3.71325 9.96525 3.303 11.361 4.43925C12.3855 5.274 12.3915 6.74175 11.8582 7.59525Z",
    fill: "#2A1812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.79699826ff80bd5da960e433934a0007.svg";
export { ForwardRef as ReactComponent };